import SvgIcon from "@mui/material/SvgIcon";

export const StockIcon = ({
  width = 24,
  height = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path d="M12 2L4 6v12l8 4 8-4V6L12 2z" />
      <path d="M4 6l8 4 8-4" />
      <path d="M12 10v12" />
    </svg>
  );
};

export const StockProductsIcon = (props) => (
  <SvgIcon {...props}>
    {/* Top box */}
    <path d="M12 2 5 5.5 12 9l7-3.5L12 2z" />

    {/* Left box */}
    <path d="M5 5.5v7L12 16v-7L5 5.5z" />

    {/* Right box */}
    <path d="M19 5.5v7L12 16v-7l7-3.5z" />

    {/* Bottom shelf */}
    <path d="M4 18h16" stroke="currentColor" strokeWidth="1.8" />

    {/* Small product boxes */}
    <rect x="6" y="18.5" width="3" height="3" rx="0.5" />
    <rect x="10.5" y="18.5" width="3" height="3" rx="0.5" />
    <rect x="15" y="18.5" width="3" height="3" rx="0.5" />
  </SvgIcon>
);